import { TextCell } from "@similarweb/pro-logic-components";
import { colorsPalettes } from "@similarweb/styles";
import { Flex, Text } from "@similarweb/ui-components/foundations";

import { NO_DATA_HYPHEN } from "app/pages/sales-intelligence/constants/common";
import type { RegionalDomainItem } from "app/pages/sales-intelligence/modules/company-analysis/types/competitors";
import siNavigator from "app/pages/sales-intelligence/services/siNavigator";
import { useTranslation } from "pro-features/components/WithTranslation";

import { StyledCount, StyledDomain } from "./styles";

const DATA_AUTOMATION_COMPANY_DOMAINS_SUMMARY = "company-domains-summary";

type Props = {
    value: readonly RegionalDomainItem[];
};

export const CompanyDomainsTooltipCell = ({ value: companyDomains }: Props) => {
    const translate = useTranslation();

    if (!companyDomains || companyDomains.length === 0) {
        return <TextCell>{NO_DATA_HYPHEN}</TextCell>;
    }

    const [mainDomain] = companyDomains;
    const regionalDomain = mainDomain && mainDomain.regionalDomain

    return (
        <Flex
            data-automation={DATA_AUTOMATION_COMPANY_DOMAINS_SUMMARY}
            columnGap="4px"
            alignItems="center"
            minWidth={0}
            flex="0 1 auto"
        >
            {regionalDomain ? (
                <StyledDomain
                    data-automation={`${DATA_AUTOMATION_COMPANY_DOMAINS_SUMMARY}-name`}
                    fontVariant="subtitle2"
                    color={colorsPalettes.carbon[500]}
                >
                    {regionalDomain}
                </StyledDomain>
            ) : null}

            {companyDomains.length > 1 && regionalDomain ? (
                <StyledCount
                    data-automation={`${DATA_AUTOMATION_COMPANY_DOMAINS_SUMMARY}-count`}
                    fontVariant="body2"
                    color={colorsPalettes.carbon[300]}
                >
                    ·&nbsp;
                    <Text
                        as="a"
                        href={siNavigator.getToCompanyDigitalAssetsPageLink(regionalDomain)}
                        fontVariant="input2"
                        color={colorsPalettes.blue[400]}
                    >
                        {translate('si.common.count-domains', { count: companyDomains.length })}
                    </Text>
                </StyledCount>
            ) : null}
        </Flex>
    );
};
